import { useState } from "react";
import { EditSvg } from "../../../icons";
import Modal from "../Modal";
import CreateService from "../../../pages/tv-app/my-stay/services/create-service";
import { IOffer } from "../../../utils/types";
import classNames from "classnames";

interface EditOfferProps {
  data: IOffer | null;
  showIcon?: boolean;
  Icon?: any;
  defaultOpen?: boolean;
  onClose?: () => void;
  isDraftEditOffer?: boolean;
  disabled?: boolean;
  createNew?: boolean;
}
const EditActivity: React.FC<EditOfferProps> = ({
  data,
  showIcon = true,
  Icon,
  defaultOpen = false,
  onClose,
  isDraftEditOffer,
  disabled,
  createNew = false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(defaultOpen);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    onClose?.();
  };

  return (
    <>
      {showIcon ? (
        Icon ? (
          <div onClick={disabled ? undefined : openModal}>{Icon}</div>
        ) : (
          <div
            onClick={disabled ? undefined : openModal}
            className={classNames(
              "h-6 w-6 rounded-[3.63px] bg-[rgba(99,98,231,0.2)] flex items-center justify-center",
              disabled ? "opacity-50" : "cursor-pointer"
            )}
          >
            <EditSvg color="#6362E7" />
          </div>
        )
      ) : null}
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        title={`${!createNew ? "Edit " : ""}Services`}
        headerClassName="px-6"
        modelContentClassName="mt-1"
        className="w-[60%] mx-auto rounded-lg bg-white shadow-lg p-0 pb-6"
      >
        <div className="max-h-[75vh] overflow-y-auto p-6 pt-0">
          <CreateService
            activityData={data!}
            isEditActivity={!isDraftEditOffer && !createNew}
            createNew={createNew}
            onSuccess={() => closeModal()}
            isDraftEditOffer={isDraftEditOffer}
          />
        </div>
      </Modal>
    </>
  );
};

export default EditActivity;
